import React, { FC, ReactNode, useCallback } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { faColumns, faTable } from '@fortawesome/pro-light-svg-icons';
import { PageView } from 'src/models/users/Preferences/types';
import ModeButton from 'src/shared/ModeButton';

interface IProps {
  extra?: ReactNode;
  onToggleView: (view: PageView) => void;
  currentView: PageView;
  tableViewText?: string;
  cardViewText?: string;
}

const ViewOptionsDropDownOverlay: FC<IProps> = props => {
  const { extra, onToggleView, currentView, tableViewText, cardViewText } = props;
  const { t } = useTranslation();

  const onChangeView = useCallback(
    (view: PageView) => {
      if (view !== currentView) {
        onToggleView(view);
      }
    },
    [currentView, onToggleView]
  );

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('Common.viewOptions')}</div>
      <div className={styles.content}>
        <ul className={styles.viewActions}>
          <li className={styles.viewAction}>
            <ModeButton
              icon={faTable}
              onChangeMode={onChangeView}
              title={tableViewText || t('Common.tableView')}
              mode={PageView.table}
              isActive={currentView === PageView.table}
              className={styles.button}
            />
          </li>
          <li className={styles.viewAction}>
            <ModeButton
              icon={faColumns}
              onChangeMode={onChangeView}
              title={cardViewText || t('Common.cardsView')}
              mode={PageView.board}
              isActive={currentView === PageView.board}
              className={styles.button}
            />
          </li>
        </ul>
        {extra && <div className={styles.extra}>{extra}</div>}
      </div>
    </div>
  );
};

export default ViewOptionsDropDownOverlay;
